"use strict";
module.exports = require("./lib/client/phone");



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/griffin-paypal/phone.js
// module id = 258
// module chunks = 4 5 6 7 8 9 10